let tip = null

function getTip() {
    if (tip) return tip
    tip = document.createElement('div')
    Object.assign(tip.style, {
        position: 'fixed',
        background: '#1f2937',
        color: '#f9fafb',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '11px',
        lineHeight: '1.5',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        maxWidth: '360px',
        zIndex: '99999',
        pointerEvents: 'none',
        opacity: '0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    })
    document.body.appendChild(tip)
    return tip
}

// Render plain text, or a { type, name } pair with the type muted above the
// name so the two read as distinct. Built as nodes (never innerHTML) so tag
// values can't inject markup.
function setContent(t, value) {
    t.textContent = ''
    if (value && typeof value === 'object') {
        if (value.type) {
            const typeEl = document.createElement('div')
            typeEl.textContent = value.type
            typeEl.style.color = '#9ca3af'
            typeEl.style.fontSize = '10px'
            typeEl.style.marginBottom = '2px'
            t.appendChild(typeEl)
        }
        const nameEl = document.createElement('div')
        nameEl.textContent = value.name || ''
        nameEl.style.color = '#f9fafb'
        nameEl.style.fontWeight = '500'
        t.appendChild(nameEl)
    } else {
        t.textContent = value
    }
}

// Show the shared tooltip anchored above `el` (flips below when near the top).
export function showTooltip(el, text) {
    if (!text || (typeof text === 'object' && !text.type && !text.name)) return
    const t = getTip()
    setContent(t, text)
    const r = el.getBoundingClientRect()
    const vw = document.documentElement.clientWidth
    const tw = t.offsetWidth
    // Center over the target, then keep it inside the viewport so it never
    // gets squeezed against an edge into a tall, narrow column.
    const left = Math.max(8, Math.min(r.left + r.width / 2 - tw / 2, vw - tw - 8))
    const top = r.top - 6
    t.style.top = `${top < 10 ? r.bottom + 6 : top}px`
    t.style.left = `${left}px`
    t.style.transform = 'translateY(-100%)'
    t.style.opacity = '1'
}

export function hideTooltip() {
    if (tip) tip.style.opacity = '0'
}

export default {
    mounted(el, { value }) {
        el._tooltipText = value
        el.addEventListener('mouseenter', (el._show = () => showTooltip(el, el._tooltipText)))
        el.addEventListener('mouseleave', (el._hide = hideTooltip))
    },
    updated(el, { value }) {
        el._tooltipText = value
    },
    unmounted(el) {
        el.removeEventListener('mouseenter', el._show)
        el.removeEventListener('mouseleave', el._hide)
        hideTooltip()
    },
}
